import React, { Suspense, useEffect, useState } from 'react'
import { Outlet, useNavigate,useLocation } from 'react-router-dom'
import { NavBar, Skeleton } from 'antd-mobile'
export default function Business() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [title,setTitle] = useState('CRM') 
  useEffect(()=>{
    if (pathname.includes('/list')) {
      setTitle('我的进件')
    } else if(pathname.includes('houseAdd')){
      setTitle('新增房贷进件')
    }else if(pathname.includes('houseAgent')){
      setTitle('新增房贷经纪业务')
    }else if(pathname.includes('add')){
      setTitle('新增进件')
    }else if(pathname.includes('/detail')){
      setTitle('进件详情')
    }else if(pathname.includes('money')){
      setTitle('放款信息')
    }else if(pathname.includes('upload')){
      setTitle('上传凭证')
    }else if(pathname.includes('edit')){
      setTitle('重新上传')
    }else if(pathname.includes('reject')){
      setTitle('驳回进件')
    }else if(pathname.includes('appeal')){
      setTitle('驳回进件')
    }else if(pathname.includes('proof')){
      setTitle('凭证驳回')
    }else if(pathname.includes('pending')){
      setTitle('渠道进件')
    }else if(pathname.includes('service')){
      setTitle('客服协助')
    }else if(pathname.includes('houseSignCard')){
      setTitle('房贷卡分期数据')
    }else if(pathname.includes('houseBankManager')){
      setTitle('在线房贷经理')
    }else if(pathname.includes('houseSign')){
      setTitle('房屋交易协助对接数据')
    }else if(pathname.includes('housePhoto')){
      setTitle('按揭进件数据')
    }else if(pathname.includes('houseSetBrokerage')){
      setTitle('设置返佣账户')
    }else if(pathname.includes('houseBrokerage')){
      setTitle('房贷返佣')
    }else if(pathname.includes('houseRecommendAdd')){
      setTitle('新增优选房源')
    }else if(pathname.includes('houseRecommendList')){
      setTitle('优选房源')
    }else if(pathname.includes('houseChannelDetail')){
      setTitle('房贷渠道详情')
    }else if(pathname.includes('houseChannelAdd')){
      setTitle('新增房贷渠道')
    }else if(pathname.includes('houseChannel')){
      setTitle('房贷渠道')
    }else if(pathname.includes('houseUpload')){
      setTitle('上传房贷材料')
    }else if(pathname.includes('houseDetail')){
      setTitle('房贷详情')
    }else if(pathname.includes('house')){
      setTitle('房贷进件数据')
    }else if(pathname.includes('ysb')){
      setTitle('意数宝')
    }else if(pathname.includes('calculator')){
      setTitle('贷款计算器')
    }else if(pathname.includes('stat')){
      setTitle('业务统计')
    }else if(pathname.includes('financeAuditNew')){
      setTitle('提额审批')
    }else if(pathname.includes('financeAuditDetail')){
      setTitle('审批进度')
    }else if(pathname.includes('financeAudit')){
      setTitle('超额度审批')
    }else if(pathname.includes('signin')){
      setTitle('国如金融信息服务（上海）有限公司')
    }
  },[pathname])
  return (
    <Suspense 
      fallback={<>
          <Skeleton.Title animated />
          <Skeleton.Paragraph lineCount={5} animated />
        </>}
      >
      <NavBar 
        className={['crm-header',pathname.includes('houseRecommendList') ? 'house-recommend-header' : null]}
        onBack={()=>navigate(-1)}
      >
        {title}
      </NavBar>
      <Outlet/>
    </Suspense>
  )
}
